module.exports = __webpack_public_path__ + "static/assets/fa2c5c6d9dd6e5c64724929ebcf0841d.png";